<template>
  <v-form ref="form" @submit.prevent="login">
    <v-text-field
      v-model="username"
      label="Username or Email"
      placeholder="Enter your username or email"
      prepend-inner-icon="mdi-account-outline"
      density="comfortable"
      variant="outlined"
      class="mb-3"
      :rules="[v => !!v || 'Username or email is required']"
    />

    <v-text-field
      v-model="password"
      label="Password"
      placeholder="Enter your password"
      prepend-inner-icon="mdi-lock-outline"
      density="comfortable"
      variant="outlined"
      class="mb-4"
      :rules="[v => !!v || 'Password is required']"
      :append-inner-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
      :type="showPassword ? 'text' : 'password'"
      @click:append-inner="showPassword = !showPassword"
    />

    <v-btn
      type="submit"
      color="primary"
      size="large"
      block
      class="btn-modern font-weight-bold text-white mb-2"
      :loading="loading"
      prepend-icon="mdi-login"
    >
      Sign In
    </v-btn>
  </v-form>

  <v-snackbar
    v-model="snackbar.show"
    :color="snackbar.color"
    :timeout="5000"
    location="top"
    rounded="lg"
  >
    <div class="d-flex align-center">
      <v-icon class="mr-2">{{ snackbar.color === 'error' ? 'mdi-alert-circle' : 'mdi-check-circle' }}</v-icon>
      {{ snackbar.text }}
    </div>
    <template #actions>
      <v-btn
        color="white"
        variant="text"
        icon="mdi-close"
        @click="snackbar.show = false"
      />
    </template>
  </v-snackbar>
</template>

<script>
import { ref } from 'vue'
import { useStore } from 'vuex'

export default {
  name: 'LoginForm',
  emits: ['login-success'],
  setup(props, { emit }) {
    const store = useStore()
    const form = ref(null)
    const username = ref('')
    const password = ref('')
    const showPassword = ref(false)
    const loading = ref(false)
    const snackbar = ref({
      show: false,
      text: '',
      color: 'error',
    })

    const login = async () => {
      const { valid } = await form.value.validate()
      if (!valid) return

      loading.value = true
      try {
        await store.dispatch('auth/login', {
          username: username.value,
          password: password.value,
        })
        snackbar.value = {
          show: true,
          text: 'Login successful! Redirecting...',
          color: 'success',
        }
        setTimeout(() => {
          emit('login-success')
        }, 500)
      } catch (error) {
        console.error('Login failed:', error)
        snackbar.value = {
          show: true,
          text: 'Login failed. Please check your username and password.',
          color: 'error',
        }
      } finally {
        loading.value = false
      }
    }

    return {
      form,
      username,
      password,
      showPassword,
      loading,
      login,
      snackbar,
    }
  },
}
</script>

